const errorPatterns: Array<{ pattern: string; message: string }> = [
    { pattern: "Failed to fetch", message: "Connection problem. Please check your internet and try again." },
];

export function humanizeErrorMessage(error: string | undefined): string | undefined {
    if (!error) return undefined;

    for (const { pattern, message } of errorPatterns) {
        if (error.includes(pattern)) {
            return message;
        }
    }

    return error;
}
